webpackJsonp([15346480593252],{

/***/ 1646:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Allergy","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"insertedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-allergy-48e8fbaaffc09dd03538.js